import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "admin-lte/dist/css/AdminLTE.min.css";
import "admin-lte/dist/css/skins/skin-blue.min.css";
import "font-awesome/css/font-awesome.min.css";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.min.js";
import "admin-lte/dist/js/adminlte.min.js";
// import 'admin-lte/dist/js/pages/dashboard.js';
import "./static/font/iconfont/iconfont.css";
import "./static/css/admin.css";
import Moment from "moment";
import echarts from "echarts";
import Loading from "vue-loading-overlay";
import VueHtml5Editor from "vue-html5-editor";
import editorOpt from "./components/initHTMLEditor";
import printer from "./components/print";
import { Alert } from "./components/dialog";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import axios from "axios";
// import layer from 'vue-layer';
// import 'vue-layer/lib/vue-layer.css';
// Vue.prototype.$layer = layer(Vue);
import { req as request, post, get } from "./api/axiosFun";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
import EleUploadImage from "vue-ele-upload-image";
Vue.component(EleUploadImage.name, EleUploadImage);
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Element);
Vue.prototype.$echarts = echarts;
import VTooltip from "v-tooltip";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Video from 'video.js';
import 'video.js/dist/video-js.css';
Vue.prototype.$video = Video;
import hls from 'videojs-contrib-hls';
Vue.use(hls); // 要播放hls流, 这哥们就要上场
Vue.use(VTooltip);
Vue.use(VueHtml5Editor, editorOpt);

Vue.component(VueQrcode.name, VueQrcode);
Vue.component("flat-pickr", flatPickr);
Vue.use(Loading);
Vue.use(VueToast);
Vue.use(printer);

Vue.prototype.$dialog = {
  alert: Alert
};

// 定义全局时间戳过滤器
Vue.filter("datefmt", function (input, fmtstring) {
  return Moment.unix(input).format(fmtstring);
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requireAuth)) {
    let user = window.window.sessionStorage.user;
    user = user && JSON.parse(user);
    user = {
      ...store.state.userInfo,
      ...user
    };

    if (user.id) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

router.afterEach((to, from, next) => {
  console.log(to, from);
  let specialPages = [
    "/",
    "/products",
    "/service",
    "/service_post",
    "/board_new",
    "/service_active",
    "/login",
    "/board_new_sz",
    "/board"
  ];
  if (specialPages.indexOf(to.path) > -1) {
    store.commit("toggleHiddenMenu");
  } else {
    store.commit("toggleShowMenu");
  }
  if (
    ["/statistics", "/board", "/board_new", "/board_new_sz"].indexOf(to.path) >
    -1
  ) {
    store.commit("toggleIsStatisticsPage");
  } else {
    store.commit("toggleNotStatisticsPage");
  }
  if (["/board", "/board_new", "/board_new_sz"].indexOf(to.path) > -1) {
    store.commit("toggleHiddenTop");
  } else {
    store.commit("toggleShowTop");
  }
});

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Vue.$toast.open({
            message: "请先登录!",
            type: "warning",
            position: "top"
          });
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
          });
      }
    }
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);

Vue.prototype.$api = { request, post, get };
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
